import { render } from "./swapPageTabs.vue?vue&type=template&id=7a5dd4a6&scoped=true&lang=pug"
import script from "./swapPageTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./swapPageTabs.vue?vue&type=script&setup=true&lang=js"

import "./swapPageTabs.vue?vue&type=style&index=0&id=7a5dd4a6&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5dd4a6"]])

export default __exports__